import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
//import ListItemText from "@mui/material/ListItemText";
//import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
//import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import "./Dialog.css";
import "../pages/Categories.css";

// Function to speak the plant name
const pronouncePlantName = (name) => {
  const speechSynthesis = window.speechSynthesis;
  const speechText = new SpeechSynthesisUtterance(name);
  speechSynthesis.speak(speechText);
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return React.createElement(
    Slide,
    Object.assign({ direction: "up", ref: ref }, props)
  );
});

export default function FullScreenDialog(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const info=props?.plantDetInfo?.additional_info.slice(0,35)+'...';
  // Function to get the image source based on the plant category
  const getCategoryLogo = (category) => {
    // Add your logic to determine the category and return the corresponding image source
    switch (category) {
      case "Herb":
        return "herb_logo.png";
      case "Tree":
        return "tree_logo.png";
      case "Shrub":
        return "shrubs_logo.png";
      // Add more cases for other categories as needed
      default:
        return null; // Return null if no matching category is found
    }
  };

  return (
    <React.Fragment>
      <Link
        className="desc"
        onClick={handleClickOpen}
        style={{ display: "flex", alignItems: "center", width: "300px" }}
      >
        <div className="description" style={{ flex: "1", marginRight: "9px" }}>
          <Typography
            style={{
              alignContent: "left",
              color: "green",
              fontWeight: "900",
              fontSize: "12px",
            }}
          >
            {props?.english} ({props?.plantInfo?.scientific_name})
          </Typography>

          <Typography style={{ color: "black", fontSize: "11px" }}>
            {info}
          </Typography>
        </div>
        <div className="plantlg">
          <img
            src={getCategoryLogo(props?.plantInfo?.category)} // Get the category logo based on the plant category
            alt="Plant Category Logo"
            // style={{}} // Adjust dimensions as needed
          />
        </div>
      </Link>

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{ zIndex: 9999, backgroundColor: "honeydew" }}
      >
        <AppBar
          sx={{
            position: "relative",
            backgroundColor: "#042705",
          }}
        >
          <Toolbar>
            <Typography
              sx={{
                ml: 10,
                flex: 5,
              }}
              variant="h4"
              component="div"
              style={{
                fontWeight: "600",
                fontSize: "20px",
                marginLeft: "0%",
                fontFamily: "Fredoka, sans-serif",
              }}
            >
              Plant Details
            </Typography>

            <Button autoFocus color="inherit" onClick={handleClose}>
              <CloseIcon style={{ fontSize: "24px", fontWeight: "900" }} />
            </Button>
          </Toolbar>
        </AppBar>
        <List>
          <Typography variant="h2" />
          <div className="container py-5">
            <div className="row">
              <div className="col-md-5">
                <img
                  src={`${props?.image?.images}`}
                  alt="plant img"
                  className="img-fluid mx-auto d-block"
                  style={{
                    height: "250px",
                    width: "100%",
                    borderRadius: "10px",
                    marginTop: "-7%",
                  }}
                />
              </div>
              <div
                className="col-md-7 py-0"
                style={{
                  marginTop: "2%",
                }}
              >
                <p className="text">
                  <h2
                    style={{
                      fontFamily: "Fredoka, sans-serif",
                      fontWeight: "800",
                      fontSize: "20px",
                    }}
                  >
                    Plant Name:{" "}
                    <span
                      className="text text-success"
                      style={{
                        fontFamily: "Fredoka, sans-serif",
                        fontWeight: "500",
                        fontSize: "20px",
                      }}
                    >
                      {props?.english}{" "}
                    </span>{" "}
                    <IconButton
                      onClick={() => pronouncePlantName(props?.english)}
                      style={{
                        backgroundColor: "#4CAF50",
                        color: "white",
                        borderRadius: "50%",
                        padding: "10px",
                        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
                        transition: "0.3s",
                      }}
                    >
                      <VolumeUpIcon />
                    </IconButton>
                  </h2>
                  <h2
                    style={{
                      fontFamily: "Fredoka, sans-serif",
                      fontWeight: "800",
                      fontSize: "20px",
                    }}
                  >
                    Indian Language:{" "}
                    <span
                      className="text text-success"
                      style={{
                        fontFamily: "Fredoka, sans-serif",
                        fontWeight: "500",
                        fontSize: "20px",
                      }}
                    >
                      {props?.kannada},{props?.hindi},{props?.telugu},
                      {props?.tamil}{" "}
                    </span>
                  </h2>

                  <h2
                    style={{
                      fontFamily: "Fredoka, sans-serif",
                      fontWeight: "800",
                      fontSize: "20px",
                    }}
                  >
                    Scientific Name:{" "}
                    <span
                      className="text text-success"
                      style={{
                        fontFamily: "Ubuntu, sans-serif",
                        fontSize: "20px",
                        fontWeight: "normal",
                      }}
                    >
                      {props?.plantInfo?.scientific_name}
                    </span>
                  </h2>
                </p>
              </div>
              <p
                className="py-2"
                style={{
                  fontFamily: "Ubuntu, sans-serif",
                  fontWeight: "500",
                  fontSize: "15px",
                  textAlign: "justify",
                }}
              >
                <h2
                  style={{
                    fontFamily: "Fredoka, sans-serif",
                    fontWeight: "750",
                    fontSize: "20px",
                  }}
                >
                  {props?.plantInfo?.category}:
                </h2>
                {props?.plantDetInfo?.additional_info}
                <h2
                  style={{
                    fontFamily: "Fredoka, sans-serif",
                    fontWeight: "750",
                    fontSize: "20px",
                    marginTop: "2%",
                  }}
                >
                  Uses:
                </h2>
                {props?.plantDetInfo?.uses}
              </p>
            </div>
            <div className="row">
              <div className="col">
                <h2
                  className="text"
                  style={{
                    fontFamily: "Fredoka, sans-serif",
                    fontWeight: "750",
                    fontSize: "20px",
                    marginTop: "0%",
                  }}
                >
                  Demerits:
                </h2>{" "}
                <p
                  style={{
                    fontFamily: "Ubuntu, sans-serif",
                    fontWeight: "500",
                    fontSize: "15px",
                    textAlign: "justify",
                  }}
                >
                  {props?.plantDetInfo?.demerits}
                </p>
              </div>
            </div>
          </div>

          <Divider />
        </List>
      </Dialog>
    </React.Fragment>
  );
}
